export default __webpack_public_path__ + "static/media/8.3d5750ac.jpg";